import React from 'react';
import PhoneInput, { CountryData } from 'react-phone-input-2';
import _get from 'lodash/get';
import _noop from 'lodash/noop';
import { CountryEnum } from 'graphql-common';
import './InputTel.scss';

export type InputTelValue = {
  country: CountryEnum;
  countryCode: string;
  number: string;
  phone: string;
};

interface Props {
  disabled?: boolean;
  hasError?: boolean;
  id?: string;
  onChange?: (v: InputTelValue) => void;
  onlyCountries?: string[];
  value?: InputTelValue;
}

function InputTel(props: Props) {
  const {
    disabled,
    hasError,
    id,
    onChange = _noop,
    onlyCountries,
    value,
  } = props;
  const onChangeHandler = (phone: string, countryData: CountryData) => {
    const countryCode = _get(countryData, 'dialCode');
    const country = _get(countryData, 'countryCode', '').toUpperCase();
    const number = countryCode
      ? phone.replace(new RegExp(`^${countryCode}`), '')
      : phone;
    onChange({
      number,
      phone,
      country,
      countryCode,
    });
  };
  return (
    <PhoneInput
      key={onlyCountries?.length}
      inputProps={{ id, autoComplete: 'off' }}
      value={value?.phone}
      onChange={onChangeHandler}
      placeholder=" "
      country="fr"
      onlyCountries={onlyCountries}
      inputClass={hasError ? 'form-control--hasError' : undefined}
      disabled={disabled}
    />
  );
}

export default InputTel;
